var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H19V4C19 3.46957 18.7893 2.96086 18.4142 2.58579C18.0391 2.21071 17.5304 2 17 2H11C10.4696 2 9.96086 2.21071 9.58579 2.58579C9.21071 2.96086 9 3.46957 9 4V6H4V8H6V23C6 23.7956 6.31607 24.5587 6.87868 25.1213C7.44129 25.6839 8.20435 26 9 26H19C19.7956 26 20.5587 25.6839 21.1213 25.1213C21.6839 24.5587 22 23.7956 22 23V8H24V6ZM11 4H17V6H11V4ZM20 23C20 23.2652 19.8946 23.5196 19.7071 23.7071C19.5196 23.8946 19.2652 24 19 24H9C8.73478 24 8.48043 23.8946 8.29289 23.7071C8.10536 23.5196 8 23.2652 8 23V8H20V23Z",
    fill: "#606368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H11V20H13V12Z",
    fill: "#606368"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12H15V20H17V12Z",
    fill: "#606368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinGray);
export default __webpack_public_path__ + "static/media/bin-gray.7dc6a9d4d8461989d6b2523702d4387e.svg";
export { ForwardRef as ReactComponent };